import React from 'react'
import PropTypes from 'prop-types'

import {ProgressIndicator, TdWithoutPadding, WhiteBackground} from './styles'

const TableProgressBar = ({progress, columns}) => {
  if (progress >= 100) {
    return null
  }
  return (
    <tr>
      <TdWithoutPadding colSpan={columns}>
        <WhiteBackground>
          <ProgressIndicator progress={progress} />
        </WhiteBackground>
      </TdWithoutPadding>
    </tr>
  )
}

TableProgressBar.propTypes = {
  progress: PropTypes.number.isRequired,
  columns: PropTypes.number,
}

TableProgressBar.defaultProps = {
  columns: 1,
}

export default TableProgressBar
